import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'background' || groupKey === 'feature-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseWealthSavingsHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const backgroundImage = getMediaUrl(section, 'background');

  if (!fields.title || !backgroundImage) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    backgroundImage,
  };
};

export const parseWealthSavingsApproachContent = (page) => {
  const section = getSection(page, 'approach');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const paragraphs = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`paragraph-${index}`];
    if (!value) {
      break;
    }
    paragraphs.push(value);
  }

  return {
    title: fields.title,
    paragraphs,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseWealthSavingsProductsContent = (page) => {
  const section = getSection(page, 'products');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`product-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      tagline: fields[`product-${index}-tagline`] || '',
      title,
      cardText: fields[`product-${index}-text`] || '',
      url: fields[`product-${index}-url`] || '',
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'Products',
    linkText: fields.linkText || 'View Product Details',
    items,
  };
};

export const parseWealthSavingsSecurityContent = (page) => {
  const section = getSection(page, 'security');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || '',
    items,
  };
};

export const parseWealthSavingsHowToGetStartedContent = (page) => {
  const section = getSection(page, 'how-to-get-started');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const steps = [];
  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`step-${index}-title`];
    if (!title) {
      break;
    }

    steps.push({
      number: fields[`step-${index}-number`] || `${index}.`,
      title,
      description: fields[`step-${index}-description`] || '',
    });
  }

  if (steps.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    steps,
  };
};

export const parseWealthSavingsBuildYourHeritageContent = (page) => {
  const section = getSection(page, 'build-your-heritage');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
  };
};
